// apps/web/src/pages/AdminBoatDetail.tsx
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import {
  clearApproval,
  saveBoat,
  setApproval,
  useBoat,
  type BoatInput,
} from '../lib/boats';
import BoatForm from '../components/BoatForm';
import type { ApprovalSavePayload } from '../components/AdminApprovalSection';

export default function AdminBoatDetail() {
  const { uid = '', boatId = '' } = useParams();
  const { user } = useAuth();
  const { boat, loading } = useBoat(boatId);
  const [error, setError] = useState<string | null>(null);

  if (loading) return <p>Laddar…</p>;
  if (!boat) return <p>Båt hittades inte.</p>;

  async function handleSubmit(values: BoatInput) {
    setError(null);
    try {
      await saveBoat(boatId, values);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  async function handleApproval(payload: ApprovalSavePayload) {
    if (!user) return;
    setError(null);
    try {
      if (payload.state === 'cleared') {
        await clearApproval(boatId);
      } else {
        await setApproval(
          boatId,
          { approved: payload.state === 'approved', note: payload.note },
          user.uid,
        );
      }
    } catch (e) {
      setError((e as Error).message);
    }
  }

  return (
    <div className="space-y-4">
      <Link to={`/admin/medlemmar/${uid}`} className="text-sm underline">
        ← Tillbaka
      </Link>
      <h1 className="text-xl font-bold">
        {boat.name ?? '(namnlös båt)'}
      </h1>
      {error && <p className="text-sm text-red-700">{error}</p>}
      <BoatForm
        boatId={boatId}
        initial={{
          name: boat.name,
          model: boat.model,
          hullSerialNumber: boat.hullSerialNumber,
          modelYear: boat.modelYear,
          modelYearUnknown: boat.modelYearUnknown,
          engine: boat.engine,
          insuranceCompany: boat.insuranceCompany,
          measurementCert: boat.measurementCert,
          selfDeclaration: boat.selfDeclaration,
        }}
        approval={boat.approval}
        mode="admin"
        onSave={handleSubmit}
        onApprovalSave={handleApproval}
      />
    </div>
  );
}
